const basic = (request, api_config) => {
  const prefix = 'Basic'

  const Index = async(data) => {
    const result = await request({
      url: `${api_config}/${prefix}/Index`,
      method: 'get',
      params: data
    })
    return result
  }

  return {
    Index
  }
}

export default basic
